<div class="container">
    <div class="section-title">
        <h2>{{'main_title_faq' | translate}}</h2>
        <div class="bar"></div>
        <p>{{'sub_title_faq' | translate}}</p>
    </div>


    <div class="row align-items-center">
        <div class="col-lg-6 col-md-12">
            <div class="faq-accordion-content">
                <div class="accordion" id="faqAccordion">
                    <div class="card">
                        <div class="card-header" id="headingOne">
                            <button type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                {{'faq_question_1' | translate}}
                                <i class="fa fa-chevron-down"></i>
                            </button>
                        </div>

                        <div id="collapseOne" class="collapse show" data-bs-parent="#faqAccordion">
                            <div class="card-body">
                                <p>{{'faq_answer_1' | translate}}</p>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header" id="headingTwo">
                            <button class="collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            {{'faq_question_2' | translate}}
                                <i class="fa fa-chevron-down"></i>
                            </button>
                        </div>

                        <div id="collapseTwo" class="collapse" data-bs-parent="#faqAccordion">
                            <div class="card-body">
                                <p>{{'faq_answer_2' | translate}}</p>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header" id="headingThree">
                            <button class="collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                {{'faq_question_3' | translate}}
                                <i class="fa fa-chevron-down"></i>
                            </button>
                        </div>

                        <div id="collapseThree" class="collapse" data-bs-parent="#faqAccordion">
                            <div class="card-body">
                                <p>{{'faq_answer_3' | translate}}</p>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header" id="headingFour">
                            <button class="collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                {{'faq_question_4' | translate}}
                                <i class="fa fa-chevron-down"></i>
                            </button>
                        </div>

                        <div id="collapseFour" class="collapse" data-bs-parent="#faqAccordion">
                            <div class="card-body">
                                <p>{{'faq_answer_4' | translate}}</p>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header" id="headingFive">
                            <button class="collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                {{'faq_question_5' | translate}}
                                <i class="fa fa-chevron-down"></i>
                            </button>
                        </div>

                        <div id="collapseFive" class="collapse" data-bs-parent="#faqAccordion">
                            <div class="card-body">
                                <p>{{'faq_answer_5' | translate}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-6 col-md-12">
            <div class="faq-image">
                <!-- <img src="assets/img/faq-mobile.png" alt="image"> -->
                <img src="assets/img/FAQ2.png" alt="image">
            </div>
        </div>
    </div>
</div>
